export const DAYS_TO_CLOSE_COLUMN_NAME = 'Days to Close'
export const CLOSING_DATE_COLUMN_NAME = 'Closing Date'
